module.exports = __webpack_public_path__ + "assets/img/s1.0a1fcc32.jpg";